import React, { useState } from 'react';

const CharacterPicker = ({ fontSize, fontFamily, fontWeight, textColor, onChange }) => {
  const [localFontSize, setLocalFontSize] = useState(fontSize);
  const [localFontFamily, setLocalFontFamily] = useState(fontFamily);
  const [localFontWeight, setLocalFontWeight] = useState(fontWeight);
  const [localTextColor, setLocalTextColor] = useState(textColor);

  const handleChange = (property, value) => {
    const newState = {
      fontSize: localFontSize,
      fontFamily: localFontFamily,
      fontWeight: localFontWeight,
      textColor: localTextColor,
      [property]: value
    };
    
    if (property === 'fontSize') setLocalFontSize(value);
    if (property === 'fontFamily') setLocalFontFamily(value);
    if (property === 'fontWeight') setLocalFontWeight(value);
    if (property === 'textColor') setLocalTextColor(value);
    
    onChange(newState);
  };

  const fontFamilies = [
    'Arial', 'Helvetica', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New'
  ];

  const fontWeights = [
    { name: 'Regular', value: '400' },
    { name: 'Medium', value: '500' },
    { name: 'Semi Bold', value: '600' },
    { name: 'Bold', value: '700' }
  ];

  return (
    <div className="space-y-3">
      <div>
        <label className="block text-gray-300 mb-1" style={{ fontSize: '9px' }}>Font Family</label>
        <select
          value={localFontFamily}
          onChange={(e) => handleChange('fontFamily', e.target.value)}
          className="w-full bg-gray-700 text-gray-300 px-2 py-1 rounded border border-gray-600"
          style={{ fontSize: '9px', height: '24px', backgroundColor: '#4a4a4a' }}
        >
          {fontFamilies.map(font => (
            <option key={font} value={font}>{font}</option>
          ))}
        </select>
      </div>

      <div className="flex gap-2">
        <div className="flex-1">
          <label className="block text-gray-300 mb-1" style={{ fontSize: '9px' }}>Size</label>
          <input
            type="number"
            value={localFontSize}
            onChange={(e) => handleChange('fontSize', parseInt(e.target.value) || 12)}
            className="w-full bg-gray-700 text-gray-300 px-2 py-1 rounded border border-gray-600"
            style={{ fontSize: '14px', height: '24px', backgroundColor: '#4a4a4a' }}
            min="6"
            max="144"
            placeholder="16 px"
          />
        </div>
        <div className="flex-1">
          <label className="block text-gray-300 mb-1" style={{ fontSize: '9px' }}>Weight</label>
          <select
            value={localFontWeight}
            onChange={(e) => handleChange('fontWeight', e.target.value)}
            className="w-full bg-gray-700 text-gray-300 px-2 py-1 rounded border border-gray-600"
            style={{ fontSize: '9px', height: '24px', backgroundColor: '#4a4a4a' }}
          >
            {fontWeights.map(weight => (
              <option key={weight.value} value={weight.value}>{weight.name}</option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <label className="block text-gray-300 mb-1" style={{ fontSize: '9px' }}>Text Color</label>
        <div className="flex items-center gap-1.5">
          <div 
            className="border border-gray-600 cursor-pointer flex-shrink-0"
            style={{ 
              width: '20px', 
              height: '20px',
              backgroundColor: localTextColor 
            }}
            onClick={() => document.getElementById('textColorInput').click()}
          />
          <input
            id="textColorInput"
            type="color"
            value={localTextColor}
            onChange={(e) => handleChange('textColor', e.target.value)}
            className="w-0 h-0 opacity-0"
          />
          <input
            type="text"
            value={`${localTextColor.toUpperCase()}`}
            onChange={(e) => handleChange('textColor', e.target.value)}
            className="flex-1 bg-gray-700 text-gray-300 px-2 py-1 rounded border border-gray-600"
            style={{ fontSize: '14px', height: '20px', backgroundColor: '#4a4a4a' }}
            placeholder="#000000"
          />
        </div>
      </div>
    </div>
  );
};

export default CharacterPicker;
